import { useTranslation } from 'react-i18next';

export default function ConnaitreQuartier() {
  const { t } = useTranslation('saintnicolas');

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          {/* Texte */}
          <div className="order-2 lg:order-1">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-manrope font-bold text-slate-primary mb-5 md:mb-6 leading-tight">
              {t('quartier_h2')}
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
              {t('quartier_p1')}
            </p>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              {t('quartier_p2')}
            </p>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Aerial view of modern suburban neighborhood in Saint-Nicolas Quebec with contemporary houses and cottages built 2000-2020, manicured lawns, wide paved streets, autumn light, premium residential development, tree-lined avenues, no people, documentary aerial photography style"
                alt="Maisons modernes et développement résidentiel premium à Saint-Nicolas, Lévis"
                className="w-full h-[300px] md:h-[400px] object-cover object-top"
                loading="lazy"
                width="800"
                height="600"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}